<template>
  <div id="app" class="t-wrapper">
    <header class="t-header">
      <div class="t-header__inner">
        <div class="t-header__body">
          <div class="m-user">
            <a
              class="m-user__name a-accordion js-accordion"
              v-bind:class="{'a-accordion': !showSignOut, 'a-accordion-t': showSignOut}"
              v-on:click="showSignOut=!showSignOut"
            >{{ accountId }}</a>
            <ul class="m-menu__list--underlayer a-accordion__body" v-show="showSignOut">
              <a
                class="m-menu__link m-menu__link--icon"
                v-on:click="goSignOut"
                v-if="login"
              >ログアウト</a>
            </ul>
          </div>
          <div class="m-menu">
            <ul class="m-menu__list">
              <!--<li class="m-menu__item"><a class="m-menu__link m-menu__link--icon is-active" href="#"><span class="m-menu__icon a-icon--home">PDQ dashboard</span></a></li>
              <li class="m-menu__item"><a class="m-menu__link m-menu__link--icon" href="#"><span class="m-menu__icon a-icon--chart">レポート一覧</span></a></li>-->
              <li class="m-menu__item">
                <a
                  class="m-menu__link m-menu__link--icon js-accordion"
                  v-bind:class="{'a-accordion': !showConfiguration, 'a-accordion-t': showConfiguration}"
                  v-on:click="showConfiguration=!showConfiguration"
                ><span class="m-menu__icon a-icon--settings">設定</span></a>
                <ul class="m-menu__list--underlayer a-accordion__body" v-show="showConfiguration">
                  <li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="/delivery/list-frame">配信サービス</router-link>
                  </li>
                  <li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="/delivery/list-action">アクション</router-link>
                  </li>
                  <!--<li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="#">セグメント</router-link>
                  </li>-->
                  <!--<li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="/udata/list-decision-tree">決定木</router-link>
                  </li>-->
                </ul>
              </li>
              <li class="m-menu__item">
                <a
                  class="m-menu__link m-menu__link--icon js-accordion"
                  v-bind:class="{'a-accordion': !showManagement, 'a-accordion-t': showManagement}"
                  v-on:click="showManagement=!showManagement"
                ><span class="m-menu__icon a-icon--panel">管理</span></a>
                <ul class="m-menu__list--underlayer a-accordion__body" v-show="showManagement">
                  <li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="/delivery/list-domain">ドメイン設定</router-link>
                  </li>
                  <!--<li class="m-menu__item">
                    <router-link class="m-menu__link m-menu__link--icon" to="#">ゴール設定</router-link>
                  </li>-->
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="t-header__mask"></div>
      <button class="t-header__toggle"><span class="t-header__toggle-inner"></span></button>
    </header>
    <main class="t-main">
      <div class="a-section">
        <router-view/>
      </div>
    </main>
    <div class="t-service">
      <p class="m-service__logo">PDQ</p>
    </div>
  </div>
</template>
<script>
import store from './stores'
export default {
  name: 'app',
  data: function() {
    return {
      showConfiguration: 0,
      showManagement: 0,
      showSignOut: 0
    }
  },
  computed: {
    login: { get() { return store.state.signin.login } },
    accountId: { get() { return store.state.account.accountId } }
  },
  created() {
    if (this.$route.name !== 'healthcheck') {
      store.dispatch('checkSessionId')
      store.dispatch('getAccountId')
    }
  },
  methods: {
    goSignOut: function() {
      store.dispatch('signOut', this.$router)
    }
  }
}
</script>

<style>
  @import './assets/css/style.css'
</style>



// WEBPACK FOOTER //
// src/App.vue